import { apiGet, apiPost, apiPut, apiDelete } from "../utils/api";
import { Exercise } from "../components/interfaces/Exercise";

/**
 * Servei d'exercicis (dissenyador d'exercicis, Fase 6).
 * Backend: taskgen-srv/server/routes/Exercises.js, muntat a /v1/exercise.
 */

export function getExercise(id: string, navigate?: (path: string) => void) {
    return apiGet<Exercise>('/v1/exercise/' + id, navigate);
}

export function createExercise(exercise: Exercise, navigate?: (path: string) => void) {
    return apiPost<Exercise>('/v1/exercise', exercise, navigate);
}

export function updateExercise(id: string, exercise: Exercise, navigate?: (path: string) => void) {
    return apiPut<Exercise>('/v1/exercise/' + id, exercise, navigate);
}

export function deleteExercise(id: string, navigate?: (path: string) => void) {
    return apiDelete('/v1/exercise/' + id, navigate);
}

export function cloneExercise(id: string, navigate?: (path: string) => void) {
    return apiPost<Exercise>('/v1/exercise/' + id + '/clone', {}, navigate);
}
